<template>
  <div class="app-container">
    <div class="main-body">
      <el-row class="call-title">
        <el-col :span="24">
          <i class="lc-tms-iconyunweiguanli icon-cls icon-cls-green" />
          <span class="title">角色管理</span>
        </el-col>
      </el-row>
      <div ref="searchBar" class="form-cls">
        <el-form @heightChange="_getTableHeight()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="角色名称:">
                <el-input
                  v-model.trim="queryParams.name"
                  clearable
                  type="text"
                  size="small"
                  class="input-cls input-width-6"
                  placeholder="请输入内容"
                  @keyup.enter.native="queryList"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-button plain key="query" size="small" type="primary" icon="el-icon-search" @click="queryList"> 查询 </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- </search-bar> -->
      </div>
      <div class="main-body">
        <vxe-toolbar ref="xToolbar" custom style="margin-left: 10px; padding-right: 10px">
          <template #buttons>
            <el-button plain key="set" size="small" type="primary" icon="el-icon-circle-plus" @click="addRow"> 创建角色 </el-button>
          </template>
          <template #tools>
            <vxe-pager
              align="left"
              placement="top"
              :total="total"
              :current-page.sync="queryParams.current"
              border
              :page-sizes="[100, 120, 150]"
              size="small"
              :page-size.sync="queryParams.size"
              :layouts="['PrevJump', 'PrevPage', 'Jump', 'NextPage', 'NextJump', 'Sizes', 'Total']"
              @page-change="queryList('0')"
            />
          </template>
        </vxe-toolbar>
      </div>
      <el-row class="form-cls button-cls">
        <el-col :span="24">
          <vxe-table
            id="dataListTable"
            ref="table"
            v-loading="listLoading"
            class="sortable-column-demo"
            :export-config="{}"
            :data="dataList"
            fit
            show-footer
            :height="_tableHeight"
            element-loading-text="加载中"
            border
            stripe
            column-key
            resizable
            highlight-current-row
            :resizable-config="{ minWidth: 50 }"
            :checkbox-config="{ trigger: 'row', highlight: true }"
            :custom-config="{ storage: true }"
            :scroll-y="{ gt: -1 }"
            show-overflow="tooltip"
            show-footer-overflow="tooltip"
            show-header-overflow="tooltip"
            tooltip-effect="dark"
            size="small"
            style="width: 100%"
          >
            <vxe-table-column type="seq" title="序号" width="50" align="center" fixed="left" />
            <vxe-table-column field="id" title="角色编号" sortable align="center" width="200" show-overflow-tooltip />
            <vxe-table-column field="name" title="角色名称" sortable align="center" width="250" show-overflow-tooltip />
            <vxe-table-column field="status" title="角色状态" sortable align="center" width="140">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status | statusTypeFilter" size="small">
                  {{ scope.row.status | statusFilter }}
                </el-tag>
              </template>
            </vxe-table-column>
            <vxe-table-column field="description" title="角色描述" align="center" width="240" />
            <vxe-table-column field="creater" align="center" title="创建人" sortable width="200" />
            <vxe-table-column field="created" title="创建时间" sortable align="center" width="200" />
            <vxe-table-column field="updater" title="最后修改人" sortable align="center" width="200" />
            <vxe-table-column field="updated" title="最后修改时间" sortable align="center" width="220" />
            <vxe-table-column align="center" fixed="right" title="操作" width="160">
              <template v-slot="{ row }">
                <span style="color: deepskyblue; cursor: pointer" icon="fa fa-edit" @click="editEvent(row)">编辑</span>—
                <span style="color: red; cursor: pointer" v-if="row.status === 'ENABLE'" icon="fa fa-trash-o" @click="disableEvent(row)">停用</span>
                <span style="color: darkgreen; cursor: pointer" v-if="row.status === 'DISABLE'" icon="fa fa-trash-o" @click="enableEvent(row)"
                  >启用</span
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="40%" :close-on-click-modal="false">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="130px">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="角色名称：" prop="name">
              <el-input v-model="formData.name" size="small" class="input-width-8" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="角色描述：" prop="description">
              <el-input v-model="formData.description" type="textarea" size="small" class="input-width-8" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitData">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryList, editStatus, roleEdit, roleSave } from '@/api/role'
import { getToken } from '@/utils/auth'
import CalTableHeight from '@/mixins/calTableHeight'

export default {
  mixins: [CalTableHeight],
  filters: {
    statusTypeFilter(status) {
      const statusMap = {
        ENABLE: 'success',
        DISABLE: 'danger'
      }
      return statusMap[status]
    },
    statusFilter(status) {
      const statusMap = {
        ENABLE: '正常',
        DISABLE: '禁用'
      }
      return statusMap[status]
    }
  },
  data: function () {
    return {
      total: 0,
      summary: {},
      listLoading: false,
      formData: {
        id: '',
        name: '', //角色名称
        description: '' //描述
      },
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入角色描述', trigger: 'blur' }]
      },
      // 查询条件
      queryParams: {
        name: '',
        status: '',
        current: 1,
        size: 100
      },
      dataList: [],
      dialogVisible: false,
      dialogTitle: '添加角色',
      statusFlags: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'ENABLE',
          label: '启用'
        },
        {
          value: 'DISABLE',
          label: '禁用'
        }
      ]
    }
  },
  computed: {
    headers() {
      return {
        'lc-token': getToken()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联,否则列配置将失效
      this.$refs.table.connect(this.$refs.xToolbar)
    })
  },
  activated() {
    this.queryList()
  },
  mounted() {
    // feat: fixed table height
    // table高度初始化，部分模块高度不固定需要等待dom渲染结束再计算
    this.$nextTick(() => {
      this._getTableHeight()
    })
  },
  methods: {
    // feat: fixed table height
    // 返回除table高度外的额外总高度
    _getExtraHeight() {
      return 185 + this.$refs.searchBar.offsetHeight
    },
    // 新增
    addRow() {
      this.resetForm()
      this.dialogTitle = '添加角色'
      this.dialogVisible = true
    },
    // 编辑
    editEvent(row) {
      let form = Object.assign(this.formData, row)
      this.formData = form
      this.dialogTitle = '修改角色信息'
      this.dialogVisible = true
    },
    // 停用
    disableEvent(row) {
      let params = {
        id: row.id,
        status: 'DISABLE'
      }
      editStatus(params).then(res => {
        if (res.code === 200) {
          this.$message.success('角色停用成功')
          this.queryList()
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 启用
    enableEvent(row) {
      let params = {
        id: row.id,
        status: 'ENABLE'
      }
      editStatus(params).then(res => {
        if (res.code === 200) {
          this.$message.success('角色启用成功')
          this.queryList()
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 行选中
    selectRows() {},
    // 查询
    queryList(flag) {
      this.listLoading = true
      queryList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.dataList = res.data.records
          this.total = res.data.total
        }
        this.listLoading = false
      })
    },
    // 提交数据
    submitData() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在保存...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)',
            target: document.getElementById('el-dialog')
          })
          if (this.formData.id) {
            roleEdit(this.formData).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('修改角色信息成功')
                this.resetForm()
                this.queryList()
              } else {
                this.$message.error(res.msg)
              }
              loading.close()
            })
          } else {
            roleSave(this.formData).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('新增角色成功')
                this.resetForm()
                this.queryList()
              } else {
                this.$message.error(res.msg)
              }
              loading.close()
            })
          }
        } else {
          return
        }
      })
    },
    // 重置表单
    resetForm() {
      this.formData = {
        id: '',
        name: '',
        description: ''
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.input-cls {
  width: 260px;
  font-size: 14px;
  // feat: 搜索栏过多收起
  margin-right: 10px;
}
.icon-cls-green {
  color: #67c23a;
}
.dialog-row {
  margin-top: 10px;
}
</style>

<style rel="stylesheet/scss" lang="scss">
.validFieldClass .el-input__inner {
  border-color: #f56c6c;
}
.el-pagination {
  float: right;
}
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-ghost,
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}
.vxe-table--footer .col-blue {
  background: #f2f5f0;
}
/*单号复制样式 开始*/
.copy-content {
  right: 0.1em;
  top: 0.1em;
  float: right !important;
  position: absolute !important;
}
.copy-content:hover {
  background-color: #1482f0;
  float: right !important;
  height: 1.8em;
  width: 1.8em;
}
.write-color {
  border-color: #f0f0f0;
}
/*单号复制样式 结束*/
.input-width-6 {
  width: 60% !important;
}
.input-width-7 {
  width: 70% !important;
}
.input-width-8 {
  width: 80% !important;
}
</style>
